module.exports = __webpack_public_path__ + "img/loteamento.6c810dc1.svg";